import { createFileRoute, notFound } from "@tanstack/react-router";

import { deploymentsQueries } from "@/api/resources/deployments/queries";
import { publicPortalsQueries } from "@/api/resources/publicPortals/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import PublicPortalSettingsPage from "@/components/PublicPortal/PublicPortalSettingsPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/deployments/$deployment_id/customer-portal/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.deployments"),
        icon: <Icon.DEPLOYMENTS />,
        path: "/workspaces/$workspace_id/deployments",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, deployment_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeployment = await context.queryClient.ensureQueryData(deploymentsQueries.byId(deployment_id));
    if (!currentDeployment) throw notFound();
    await context.queryClient.ensureQueryData(publicPortalsQueries.byDeploymentId(deployment_id));

    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: currentDeployment.name,
        icon: <Icon.DEPLOYMENT />,
        path: "/workspaces/$workspace_id/deployments/$deployment_id",
      },
      {
        label: i18n.t("public-portal"),
        icon: <Icon.PUBLIC_PORTAL />,
      },
    ];
    context.breadcrumbs.splice(2, 2, ...breadcrumbs);
  },
  component: PublicPortalSettingsPage,
});
